// ** React Imports
import { ChangeEvent, forwardRef, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import { styled, useTheme } from '@mui/material/styles'
import FormHelperText from '@mui/material/FormHelperText'
import Select, { SelectChangeEvent } from '@mui/material/Select'

import CustomRadioIcons from 'src/@core/components/custom-radio/icons'
import { useTranslation } from 'react-i18next'

interface Props {
  data: {
    isSelected: boolean
    value: string
    title: string
    content: string
  }[]
  fn?: any
  selectedRadio: string
}

const ReportType = forwardRef((props: Props, ref) => {
  const data = props.data
  const { t } = useTranslation()
  const initialIconSelected: string = data.filter((item) => item.isSelected)[
    data.filter((item) => item.isSelected).length - 1
  ].value

  // ** States
  const [selectedRadio, setSelectedRadio] =
    useState<string>(initialIconSelected)

  // ** Hook
  const theme = useTheme()

  const icons = [
    {
      icon: 'mdi:tag-outline',
      iconProps: {
        fontSize: '2rem',
        style: { marginBottom: 4 },
        color: theme.palette.text.secondary
      }
    },
    {
      icon: 'mdi:tag-outline',
      iconProps: {
        fontSize: '2rem',
        style: { marginBottom: 4 },
        color: theme.palette.text.secondary
      }
    },
    {
      icon: 'mdi:currency-usd',
      iconProps: {
        fontSize: '2rem',
        style: { marginBottom: 4 },
        color: theme.palette.text.secondary
      }
    },
    {
      icon: 'mdi:account-outline',
      iconProps: {
        fontSize: '2rem',
        style: { marginBottom: 4 },
        color: theme.palette.text.secondary
      }
    },
    {
      icon: 'mdi:account-outline',
      iconProps: {
        fontSize: '2rem',
        style: { marginBottom: 4 },
        color: theme.palette.text.secondary
      }
    }
  ]

  const handleRadioChange = (prop: string | ChangeEvent<HTMLInputElement>) => {
    if (typeof prop === 'string') {
      props.fn(prop)
    } else {
      props.fn((prop.target as HTMLInputElement).value)
    }
  }

  return (
    <Grid container spacing={5}>
      {data.map((item, index) => (
        <CustomRadioIcons
          key={index}
          data={data[index]}
          icon={icons[index].icon}
          selected={props.selectedRadio}
          name="custom-radios-deal"
          gridProps={{ sm: 4, xs: 12 }}
          handleChange={handleRadioChange}
          iconProps={icons[index].iconProps}
        />
      ))}
    </Grid>
  )
})

export default ReportType
